import { Tag } from "features/shared/types/tag";

export enum TagAction {
    SET_TAGS = "[TagAction] SET_TAGS",
}

interface SetTags {
    type: TagAction.SET_TAGS;
    tags: Array<Tag>;
}

export type TagActionTypes = SetTags;
